/**
 * Type of subscription purchased by the user, used as the `type` query param
 * of the payment confirmation page.
 *
 * @param {User} user
 * @param {Subscription} [newUserSubscription] the subscription just purchased (state.subscription.subscription)
 * @returns {'new'|'trial'|'renew'|'winback'}
 */
export function getSubscriptionType(user, newUserSubscription) {
    const MS_PER_DAY = 1000 * 60 * 60 * 24;
    const subscription = user.get('subscription');

    if (!subscription || newUserSubscription?.get('is_first_by_type')) {
        return 'new';
    }

    if (subscription.is_trial) {
        return 'trial';
    }

    const dateSubscriptionEndOn = new Date(subscription.end_on).getTime();
    const now = new Date().getTime();

    // If the current subscription is expired within 2 days
    if (Math.floor((now - dateSubscriptionEndOn) / MS_PER_DAY) <= 2 && subscription.active) {
        return 'renew';
    }

    return 'winback';
}
